import { ADD_COUPON, ADD_LOYALTY } from "../Actions/couponActions"

const init_State ={
    coupondata:{},
}



export const couponReducer = (store = init_State,{type,payload}) =>{
    if(type === ADD_COUPON){
        return {...store,coupondata:payload}
    }
    if(type === ADD_LOYALTY){
        return {...store,points:payload}
    }
    else {
        return store
    }
}

export const getCouponState=state=>state.coupon.coupondata